import React from 'react'
import { Route, withRouter, Switch } from 'react-router-dom'
import RequireAuth from 'components/global/RequireAuth'
import LoginPage from 'components/pages/LoginPage'
import HomePage from 'components/pages/HomePage'
import DevicePage from 'components/pages/DevicePage'
import FlatsPage from 'components/pages/FlatsPage'
import KeysPage from 'components/pages/KeysPage'
import NotFound from 'components/pages/NotFound'
import EmergencyPage from 'components/pages/EmergencyPage'
import LogsPage from 'components/pages/LogsPage'
import AccessCodesPage from 'components/pages/AccessCodesPage'
import BLEKeysPage from 'components/pages/BLEKeysPage'
import UserLogsPage from './pages/UserLogsPage'
import CameraUserLogsPage from './pages/CameraUserLogsPage'
import CameraLogsPage from "./pages/CameraLogsPage";

const App = () => (
  <Switch>
    <Route path="/login" component={LoginPage} />
    <Route exact path="/" component={RequireAuth(HomePage)} />
    <Route path="/:id/ble" component={RequireAuth(BLEKeysPage)} />
    <Route path="/:id/flats" component={RequireAuth(FlatsPage)} />
    <Route path="/:id/keys" component={RequireAuth(KeysPage)} />
    <Route path="/:id/codes" component={RequireAuth(AccessCodesPage)} />
    <Route path="/:id/emergency" component={RequireAuth(EmergencyPage)} />
    <Route path="/:id/logs" component={RequireAuth(LogsPage)} />
    <Route path="/:id/user_logs" component={RequireAuth(UserLogsPage)} />
    <Route path="/:id/camera_logs/:camera_id" component={RequireAuth(CameraLogsPage)} />
    <Route path="/:id/camera_user_logs/:camera_id" component={RequireAuth(CameraUserLogsPage)} />
    <Route path="/:id" component={RequireAuth(DevicePage)} />
    <Route component={NotFound} />
  </Switch>
)

export default withRouter(App)
